export default __webpack_public_path__ + "static/media/loading.970d0f32.svg";